import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Subscription, tap } from "rxjs";
import { PreferencesService } from "../services/preferences.service";

@Component({
  selector: "app-seed-units-chooser",
  template: `
    <span [formGroup]="seedUnitsChoiceForm">
    <label i18n="@@SelectUnits">Select Units</label> &nbsp;
    <select formControlName="seedUnitsChoice">
        <option *ngFor="let option of seedUnitChoices" [value]="option">
          {{ option }}
        </option>
      </select>
</span>
  `,
  styles: [],
})
export class SeedUnitsChooserComponent implements OnInit, OnDestroy {
  seedUnitChoices: string[] = ["L/ton", "US gal/US ton","US pt/US ton"];
  seedUnitsChoiceForm: FormGroup;
  formSub: Subscription;
  constructor(
    private preferencesService: PreferencesService,
    private fb: FormBuilder
  ) {
    
    this.seedUnitsChoiceForm = this.fb.group({
      seedUnitsChoice: [this.preferencesService.seedUnitsChoice$.getValue()],
    });

    this.formSub = this.seedUnitsChoiceForm.valueChanges
      .pipe(
        tap((values) => {
          console.log("Changing SeedUnits to ", values.seedUnitsChoice);
          this.preferencesService.seedUnitsChoice = values.seedUnitsChoice;
        })
      )
      .subscribe();
  }
  ngOnDestroy(): void {
        this.formSub.unsubscribe();
  }
  ngOnInit(): void {}
}
